export default "__VITE_ASSET__BpxcOuuM__"